// The bell in the top bar (APP_SHELL.md; K4): how many notifications I have
// not read, and the door to the center. PLAN-2026-09-26-bell B2. Clean
// (LOOKS.md Part 7). Drawn only for somebody signed in (`AppShell`).

import { useNotifications } from '../data/notifications';
import { IconButton } from '../kit/ui';

export function Bell() {
  const { unread, toggle } = useNotifications();
  return (
    <IconButton
      icon="notifications"
      label="Notifications"
      variant="quiet"
      count={unread ?? undefined}
      onClick={toggle}
    />
  );
}
